var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinBigIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5 81H64.5V53.0039C64.5 45.3239 61.112 41.0391 55.036 41.0391C48.424 41.0391 44.5 45.5039 44.5 53.0039V81H28.5V29H44.5V34.8477C44.5 34.8477 49.52 26.0391 60.832 26.0391C72.148 26.0391 80.5 32.9444 80.5 47.2324V81ZM10.268 20.6836C4.87201 20.6836 0.5 16.2758 0.5 10.8398C0.5 5.40784 4.87201 1 10.268 1C15.66 1 20.032 5.40784 20.032 10.8398C20.036 16.2758 15.66 20.6836 10.268 20.6836ZM0.5 81H20.5V29H0.5V81Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBigIcon);
export default __webpack_public_path__ + "static/media/linkedinBigIcon.1bb599dff0c0d63599a3521d38d3c7f6.svg";
export { ForwardRef as ReactComponent };